import React from 'react';

type KnownErrorBoundaryContextValue = (error: any) => boolean;

export const KnownErrorBoundaryContext = React.createContext<KnownErrorBoundaryContextValue>(
	() => false,
);

KnownErrorBoundaryContext.displayName = 'KnownErrorBoundaryContext';
